module.exports = __webpack_public_path__ + "src/assets/img/default-user-icon.b35b4d3c.svg";